module.exports = __webpack_public_path__ + "static/media/document_black.13fecd9d.svg";